import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccLead } from '@interfaces';
import { DomainDataService } from '../../../../../services';
import { AdmissionsAreaService } from '../../../admissions-area.service';
import { AdmissionsProspectsService } from '../../admissions-prospects.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'prospects-closed-leads-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './closed-leads.part.html',
})
export class ProspectsClosedLeadsViewPart implements OnInit {

	private readonly domainDataService = inject(DomainDataService);
	private readonly util = inject(UtilityService);
	private readonly pageService = inject(AdmissionsProspectsService);
	private readonly admissionsAreaService = inject(AdmissionsAreaService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.util, this.domainDataService, this.dialogService, this.admissionsAreaService.app, this.admissionsAreaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public closedAccLeads = computed<AccLead[]>(() => (this.admissionsAreaService.admissionsData()?.closedAccLeads ?? []));


	async ngOnInit() {
		await this.admissionsAreaService.loadAdmissionsData();
	}
}